import { Alert, AlertTitle, Box, Button, useTheme } from '@mui/material';
import useResponsive from '../../hooks/useResponsive';
import { HEADER, NAVBAR } from '../../config';

interface DisclaimerProps {
  disclaimerText: string | null;
  environment: string;
  isToClose: boolean;
  dismissDisclaimer: () => void;
}

function Disclaimer({ disclaimerText, environment, isToClose, dismissDisclaimer }: DisclaimerProps) {
  const isDesktop = useResponsive('up', 'lg');
  const theme = useTheme();

  const handleDontShowAgain = () => {
    dismissDisclaimer();
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        top: {
          xs: HEADER.MOBILE_HEIGHT,
          lg: HEADER.DASHBOARD_DESKTOP_HEIGHT,
        },
        left: {
          xs: 0,
          lg: isDesktop ? NAVBAR.DASHBOARD_WIDTH : 0,
        },
        right: 0,
        zIndex: theme.zIndex.appBar - 1,
        transition: theme.transitions.create(['left', 'right'], {
          duration: theme.transitions.duration.shorter,
        }),
      }}
    >
      <Alert severity="warning" sx={{ width: '100%', margin: 0, borderRadius: 0 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: 1,
          }}
        >
          <AlertTitle
            sx={{
              fontSize: { xs: '0.875rem', sm: '1rem' },
              marginRight: 1,
            }}
          >
            {environment} Environment - Do Not Enter Real Or Protected Health Information (PHI)
          </AlertTitle>
          {isToClose && (
            <Button
              variant="outlined"
              size="small"
              onClick={handleDontShowAgain}
              sx={{
                backgroundColor: '#FFE9A9',
                color: '#B98B1D',
                fontWeight: 'bold',
                borderRadius: 1,
                textTransform: 'none',
                boxShadow: 'none',
                border: 'none',
                whiteSpace: 'nowrap',
                '&:hover': {
                  backgroundColor: '#FFE9A9',
                  boxShadow: 'none',
                  border: 'none',
                },
              }}
            >
              Don't Show Again
            </Button>
          )}
        </Box>
        <Box
          sx={{
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
          }}
        >
          {disclaimerText}
        </Box>
      </Alert>
    </Box>
  );
}

export default Disclaimer;


